module.exports = __webpack_public_path__ + "assets/img/29_223.8218444f.jpg";